import { render } from "./RollenAntragstellerList.pug?vue&type=template&id=c2d0b7f6&lang=pug"
import script from "./RollenAntragstellerList.js?vue&type=script&lang=js"
export * from "./RollenAntragstellerList.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__